<template>
	<div>
		<treeselect
			v-model="selectedCategory"
			:multiple="false"
			:clearable="false"
			:options="allCategories"
			@input="categoryChange"
			:disable-branch-nodes="true"
			:default-expand-level="1"
			:placeholder="FormMSG(569, 'Select a category')"
			:class="({ 'is-invalid': isSubmitted && $v.selectedCategory.$error }, { 'disabled-treeselect': isDisabled })"
			:disabled="isDisabled"
			:append-to-body="appendToBody"
			zIndex="9999"
		>
			<div slot="option-label" slot-scope="{ node }" style="width: 300px" :class="{ 'extend-treeselect-menu': extendMenu }">
				<div class="treeselect-label" :title="node.label">{{ node.label }}</div>
			</div>
			<div slot="value-label" slot-scope="{ node }">
				<span v-if="isValueInOptions(selectedCategory)">{{ node.label }}</span>
				<span v-else>{{ FormMSG(569, 'Select a category') }}</span>
			</div>
		</treeselect>
	</div>
</template>

<script>
import globalMixin from '@/mixins/global.mixin';
import Treeselect from '@riophae/vue-treeselect';
import { isNil } from '@/shared/utils';

export default {
	name: 'CostCodeSelect',
	mixins: [globalMixin],
	components: {
		Treeselect
	},
	props: {
		allCategories: {
			type: Array,
			required: false,
			default: () => []
		},
		isSubmitted: {
			type: Boolean,
			required: false,
			default: false
		},
		editData: {
			type: Object,
			required: false,
			default: null
		},
		isDisabled: {
			type: Boolean,
			required: false,
			default: false
		},
		appendToBody: {
			type: Boolean,
			required: false,
			default: true
		},
		extendMenu: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	data() {
		return {
			selectedCategory: 0,
			elemForm: {
				category: 0,
				costcodeText: 'UNDEFINED',
				categoryText: 'UNDEFINED'
			},
			isFirstLoad: true
		};
	},
	methods: {
		searchTree(tree, key, id) {
			for (const node of tree) {
				if (node.id === id) {
					return node[key];
				}
				if (node.children) {
					const result = this.searchTree(node.children, key, id);
					if (result) return result;
				}
			}
			return null;
		},
		categoryChange(value, event) {
			if (this.allCategories.length > 0) {
				const CategoryData = this.searchTree(this.allCategories, 'data', value);
				if (CategoryData) {
					this.elemForm = {
						...this.elemForm,
						category: parseInt(value, 10),
						costcodeText: CategoryData.costCenter,
						categoryText: CategoryData.description
					};
				}
			}
		},
		isValueInOptions(valueId) {
			// Recursive function to check if the value exists in the options list
			const findValue = (options) => {
				for (const option of options) {
					if (option.id === valueId) return true;
					if (option.children && findValue(option.children)) return true;
				}
				return false;
			};
			return findValue(this.allCategories);
		},
		async setAutoSelectElement() {
			if (!isNil(this.editData)) {
				const { category } = this.editData;
				this.selectedCategory = !isNil(category) ? category : 0;
			}
		}
	},
	watch: {
		editData: {
			handler(value) {
				if (!isNil(value)) {
					this.$nextTick(async () => {
						await this.setAutoSelectElement();
					});
				}
			},
			immediate: true
		},
		elemForm: {
			handler(elem) {
				if (!this.isFirstLoad) {
					this.$emit('change', elem);
				}
				this.isFirstLoad = false;
			},
			immediate: true,
			deep: true
		}
	}
};
</script>
<style>
.disabled-treeselect {
	cursor: not-allowed;
}
</style>

<style lang="scss">
.vue-treeselect__menu:has(.extend-treeselect-menu) {
	width: 300px !important;
}
</style>
